export default "__VITE_ASSET__5f3R905q__"